/**
 * The stage shown beside the app name, or null for none. The Desktop names its own stage; a Cloud
 * deployment states the Runtime Web Client's stage at build time, empty for production.
 */
export function resolveAppStageLabel(input: {
  readonly injectedStageLabel?: string | undefined;
  readonly isDevelopmentBuild: boolean;
  readonly buildStageLabel: string | null;
}): string | null {
  if (input.injectedStageLabel !== undefined) return input.injectedStageLabel;
  if (input.isDevelopmentBuild) return "Dev";
  if (input.buildStageLabel === null) return "Alpha";
  return input.buildStageLabel === "" ? null : input.buildStageLabel;
}

export function formatAppDisplayName(input: {
  readonly baseName: string;
  readonly stageLabel: string | null;
}): string {
  return input.stageLabel === null ? input.baseName : `${input.baseName} (${input.stageLabel})`;
}

/**
 * The badge beside the app name in the sidebar: the stage, or the version where there is no stage,
 * so production Runtime Web Clients show the version their Production Promotion recorded.
 */
export function resolveAppBrandBadge(input: {
  readonly stageLabel: string | null;
  readonly version: string;
}): { readonly kind: "stage" | "version"; readonly text: string } {
  return input.stageLabel === null
    ? { kind: "version", text: `v${input.version}` }
    : { kind: "stage", text: input.stageLabel };
}
